import { inter500 } from '@/config/fonts';
import {
  mergeAttributes,
  Node,
  NodeViewProps,
  NodeViewWrapper,
  ReactNodeViewRenderer,
} from '@tiptap/react';
import classNames from 'classnames';

import { labelColorVariants } from '@/shared/styles/labelColorVariants';

const LinkComponent = (props: NodeViewProps) => {
  const linkWithoutHttps = props.HTMLAttributes.link;
  const variant = labelColorVariants['purple'];

  return (
    <NodeViewWrapper as="span" className="text-editor-link inline-block">
      <span
        className={classNames(
          'mx-1 rounded-md border px-1 py-0.5',
          variant.bgColor,
          variant.textColor,
          variant.borderColor,
          {
            [`outline outline-2 ${variant.borderColor}`]: props.selected,
          },
          inter500.className
        )}
        data-link={linkWithoutHttps}>
        {linkWithoutHttps}
      </span>
    </NodeViewWrapper>
  );
};

const LinkNode = Node.create({
  name: 'LinkNodeComponent',
  group: 'inline',
  inline: true,
  atom: true,
  addAttributes() {
    return {
      link: { default: '' },
    };
  },
  parseHTML() {
    return [
      {
        tag: 'text-editor-link',
      },
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ['text-editor-link', mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return ReactNodeViewRenderer(LinkComponent);
  },
});

export default LinkNode;
